























import {Vue, Component, Prop} from 'vue-property-decorator'

import ServiceMesh from '@/lib/serviceMesh'
import DateHelper from '@/lib/DateHelper'
import {ReservationResponse} from '@/lib/kepler/interfaces'
import Utils from '@/utils'

@Component({
  components: {
    Flex: Utils.loadComponent('proxy/Flex'),
    Chip: Utils.loadComponent('proxy/Chip'),
    Layout: Utils.loadComponent('proxy/Layout'),
    CircleStatus: Utils.loadComponent('CircleStatus'),
    Container: Utils.loadComponent('proxy/Container'),
    TopBar: Utils.loadComponent('TopBar'),
  },
  name: 'ActiveReservationPopup',
})
export default class ActiveReservationPopup extends Vue {

  @Prop() protected reservation!: ReservationResponse

  get timeLeft() {
    return DateHelper.getTimeOffset(new Date(), this.reservation.end_timestamp).formatTimeOffset('dhm')
  }

  get titlebarTitle() {
    return `${this.vehicle.brand} ${this.vehicle.model}`
  }

  get vehicle() {
    return this.reservation.vehicle_slot.vehicle
  }

  get fuelLevelImage() {
    return ServiceMesh.getImageForFuelLevel(this.vehicle)
  }
}
